import React from "react"
import autobind from "class-autobind"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import ColorPicker from "../common/ColorPicker"
import { Popover } from "material-ui"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"
interface IProps {
    readonly?: boolean
    color: string
    handleSelect(color: string): void
}
interface IState {
    openColorPicker: boolean
}

export default class PositionColor extends React.Component<IProps, IState> {
    private anchorEl
    private targetOrigin = {
        vertical: "center",
        horizontal: "left"
    }
    private anchorOrigin = {
        vertical: "center",
        horizontal: "right"
    }
    constructor(props: IProps) {
        super(props)
        this.state = {
            openColorPicker: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.anchorEl = document.getElementById("PositionColor")
    }

    render() {
        return (
            AccountStore.getScheduleEnabled() && (
                <div>
                    <label style={{ fontSize: 12 }}>
                        {checkPositionFieldAvailable('singular')
                            ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel} Color`
                            : strings.Position_Color}
                    </label>
                    <div
                        data-intercom-target={"Positions-Select-Color"}
                        id="PositionColor"
                        style={{ width: 22, height: 22, borderRadius: 11, marginTop: 7, marginLeft: 5, backgroundColor: this.props.color, border: "1px solid #efefef" }}
                        onClick={() => !this.props.readonly && this.setState({ openColorPicker: true })}
                    ></div>
                    <Popover
                        open={this.state.openColorPicker}
                        anchorEl={this.anchorEl}
                        anchorOrigin={this.anchorOrigin}
                        targetOrigin={this.targetOrigin}
                        onRequestClose={() => this.setState({ openColorPicker: false })}
                    >
                        <ColorPicker handleSelect={this.props.handleSelect} />
                    </Popover>
                </div>
            )
        )
    }
}